import React, { useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { addProductCategory } from "../../../store/actions"
import { useEffect } from "react"

const AddProductCategory = props => {
  const dispatch = useDispatch()
  document.title = "Add Product Category"

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      prod_cat_name: "",
      prod_cat_no: "",
    },
    validationSchema: Yup.object({
      prod_cat_name: Yup.string().required("Please Enter Product Category Name"),
    }),
    onSubmit: values => {
      dispatch(addProductCategory(values, props.history))
    },
  })

  const productCategory = useSelector(state => state.ProductCategory)
  const { error } = useSelector(state => ({
    error: state.ProductCategory.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Add Product Category" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="form"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="category">
                            Product Category Name
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="prod_cat_name"
                            className={
                              validation.touched.prod_cat_name && validation.errors.prod_cat_name
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="category"
                            placeholder="Enter Category"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.prod_cat_name || ""}
                          />
                          {validation.touched.prod_cat_name && validation.errors.prod_cat_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.prod_cat_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="categoryno">
                            Product Category Number
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="prod_cat_no"
                            className={
                              validation.touched.prod_cat_no && validation.errors.prod_cat_no
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="categoryno"
                            placeholder="Enter Category"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.prod_cat_no || ""}
                          />
                          {validation.touched.prod_cat_no && validation.errors.prod_cat_no ? (
                            <FormFeedback type="invalid">
                              {validation.errors.prod_cat_no}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      {productCategory && productCategory.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Adding ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Add
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default AddProductCategory
